const config = {
    oauth: {
        app_auth_token: "YXBwX2F1dGhfdG9rZW46UzlZdUVxVXJhdGc2aFRBOA==",
        user_auth_token: "dXNlcl9hdXRoX3Rva2VuOkx6bVhROEhCRTdYR01SSEw"
    },
    google: {
        client_id: "394440469465-6v95d1nahfq7mphkh483fucavnjs9kke.apps.googleusercontent.com"
    }
};

export default config;